import { TranslatedCalling } from './common';

export const check_copyright_scans = {
  type: 'thinking',
  call: () => <TranslatedCalling i18nKey="tool.check-copyright-scans.checking" />,
  'partial-call': () => <TranslatedCalling i18nKey="tool.check-copyright-scans.checking" />,
  result: () => null,
};
